export default __webpack_public_path__ + "static/PeoplePage_BG-b5d947930c0634c3bd9a3ab1d23174d0.png";